import { ConfigProvider } from "antd";
import { Provider } from "@rollbar/react";
import { BrowserRouter as Router } from "react-router-dom";
import Routes from "./routes";
import GlobalStyles from "./styles/global";
import { ChatGPT } from "./components/ChatGPT";
import DrawerModalStyles from "./styles/drawer-modal";
import ContextWrapper from "./contexts/ContextWrapper";
import ErrorBoundaryRollbar from "./components/ErrorBoundary";
import ptBR from "antd/lib/locale/pt_BR";

function App() {
  const { host } = window.location;
  const isDev = host.includes("localhost") || host.includes("dev");
  const rollbarConfig = {
    accessToken: "30ca0272bd6e40e0bd69c225fa9e2c64",
    captureUncaught: true,
    captureUnhandledRejections: true,
    payload: {
      environment: isDev ? "development" : "production",
    },
  };

  return (
    <>
      <GlobalStyles />
      <DrawerModalStyles />
      <Provider config={rollbarConfig}>
        <ErrorBoundaryRollbar>
          <ConfigProvider
            locale={ptBR}
            renderEmpty={() => "Nenhum dado encontrado"}
          >
            <Router>
              <ContextWrapper>
                <Routes />
                {/* <ChatGPT /> */}
                {/* <ZendeskWidget /> */}
              </ContextWrapper>
            </Router>
          </ConfigProvider>
        </ErrorBoundaryRollbar>
      </Provider>
    </>
  );
}

export default App;
